import Config from "../config.js";
import { createRequestOptions } from "./utils";
import { get } from "lodash";

export default () =>
  Object.freeze({
    getCustomRewardsList: async (appId, userId) => {
      const options = createRequestOptions({ appId, userId });
      const result = await fetch(
        Config.serverUrl + "/GetCustomRewards",
        options
      );
      const response = await result.json();

      return get(response, "response");
    },
    addCustomReward: async (appId, name, description) => {
      const options = createRequestOptions({ appId, name, description });
      const result = await fetch(
        Config.serverUrl + "/AddCustomReward",
        options
      );
      const response = await result.json();

      return get(response, "response");
    },
    updateCustomReward: async (id, appId, name, description) => {
      const options = createRequestOptions({ id, appId, name, description });
      const result = await fetch(
        Config.serverUrl + "/EditCustomAward",
        options
      );
      const response = await result.json();

      return get(response, "response");
    },
    deleteCustomReward: async (id, appId) => {
      const options = createRequestOptions({ id, appId });
      const result = await fetch(
        Config.serverUrl + "/DeleteCustomAward",
        options
      );
      const response = await result.json();

      return get(response, "response");
    },
  });



// WEBPACK FOOTER //
// ./src/services/customRewards.js